import { store } from "global";

export const getCurrentLiveRadioFromState = () => {
    const liveRadio = store.getState().liveRadio.currentRadio;
    return liveRadio;
};
